import IssueIntensity from "./IssueIntensity";
import IssueType from "./IssueType";

export default class Issue {
    constructor(type, intensity, affectedNodes) {
        this.type = type
        this.intensity = intensity
        this.affectedNodes = affectedNodes
    }

    getAffectedNodesIds() {

        if (this.affectedNodes.length === 0) {
            return []
        }

        let nodes = []
        for (const node of this.affectedNodes) {
            nodes.push({id: node.id})
        }
        return nodes
    }

    getHighlighting() {
        let highlights = {}

        if (this.intensity === IssueIntensity.Error) {
            highlights = {error: true}
        } else if (this.intensity === IssueIntensity.Info) {
            highlights = {info: true}
        }

        switch (this.type) {
            case IssueType.InvalidStart:
                highlights = {...highlights, output: true}
                break
            case IssueType.InvalidEnd:
                highlights = {...highlights, input: true}
                break
            case IssueType.NoValidWay:
                highlights = {...highlights, input: true, output: true}
                break
            case IssueType.DeadEnd:
                highlights = {...highlights, output: true}
                break
            case IssueType.NoIncomer:
                highlights = {...highlights, input: true}
                break
            case IssueType.BadCycle:
                highlights = {...highlights, input: true, output: true, border: true}
                break
            case IssueType.NodeUnreachable:
                highlights = {...highlights, input: true, output: true, border: true}
                break
            case IssueType.LooseConstruct:
                highlights = {...highlights, input: true, output: true, border: true}
                break
            case IssueType.Redundancy:
                highlights = {...highlights, output: true}
                break
            case IssueType.noTitle:
                highlights = {...highlights, border: true}
                break
        }

        return highlights
    }
}